/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import UserProfileDropdown from "./dropdowns/UserProfileDropdown";
import {CustomTooltip} from "../../../../app/widgets";

export const QuickUserToggler = () => {
    const credential = useSelector(state => state.context.credential);
    const uiService = useHtmlClassService();
    const {t} = useTranslation();

    const layoutProps = useMemo(() => {
        return {
            offcanvas: objectPath.get(uiService.config, "extras.user.layout") === "offcanvas",
        };
    }, [uiService]);

    return (
        <>
            {layoutProps.offcanvas && (
                <CustomTooltip
                    config={{
                        text: t("HEADER.HI_USER.TOOLTIP"),
                        placement: "bottom",
                    }}
                >
                    <div className="topbar-item">
                        <div
                            className="btn btn-icon btn-clean d-flex align-items-center btn-lg px-2"
                            id="kt_quick_user_toggle"
                        >
                            <span className="user_hi">{t("HEADER.PROFILE.HI")}</span>

                            <span className="user_name">{credential?.name || credential?.username}</span>
                            <span className="symbol symbol-35 symbol-light-success">
                                <span className={`symbol-label font-size-h5 font-weight-bold `}>
                                    {credential?.name?.[0] || credential?.username?.[0]}
                                </span>
                            </span>
                        </div>
                    </div>
                </CustomTooltip>
            )}

            {!layoutProps.offcanvas && <UserProfileDropdown />}
        </>
    );
};
